export default "__VITE_ASSET__qP9ASbs8__"